import React, {useEffect} from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {LookAugmentRealityIcon} from "../../../../common/icons";
import GLBLoader from "./GLBLoader";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";
import Button from "@mui/material/Button";

const ARButton = (props) => {
  const {url, cabinetsARBlobUrl} = props;

  useEffect(() => {
    //let url = 'https://s3.amazonaws.com/qc-3dfiles/composed/' + file + '.glb'
    //url = 'https://discoverthreejs.com/examples/assets/models/Parrot.glb';
    //url = 'https://threejs.org/examples/models/gltf/AnisotropyBarnLamp.glb';
    //url = '/images/sqft-icons/3d/Chair.glb';
    //url = 'https://qc-3dfiles.s3.amazonaws.com/ar-composer/WBC3630_Brown.glb';
    new GLBLoader(url);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeImage = () => {
    const c = document.createElement('canvas');
    const i = new Image();
    i.src = c.toDataURL();

    return i;
  }

  const makeLink = (blobUrl) => {
    console.log("blobUrl", blobUrl);
    return Object.assign(document.createElement('a'), {
      download: 'asset.usdz',
      rel: "ar",
      href: blobUrl //URL.createObjectURL(blob)
    });
  }

  const arClick = () => {
    const i = makeImage();
    const a = makeLink(cabinetsARBlobUrl)
    a.appendChild(i);

    a.click();
  }

  return (
    <Button className="ar-popup__link"
                onClick={arClick}>
      <SvgIcon>
        <LookAugmentRealityIcon/>
      </SvgIcon>
      <div>
        <b>AUGMENTED</b> REALITY
      </div>
      <div>
        <small>TAP TO ACTIVATE</small>
      </div>
    </Button>
  )
};

ARButton.propTypes = {
  url: PropTypes.string,
};

const mapStateToProps = (store) => {
  return {
    visualizersLoaded: store.serverState.visualizersLoaded,
    cabinetsARBlobUrl: store.sqftState.cabinetsARBlobUrl,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(ARButton)
  )
);
